<base-app-loader [loading]="store.appLoader()" />
<router-outlet></router-outlet>
